import React from 'react'
import Modal from 'modals/dialog'
import GroupClientStateProvider from 'state/group'
import { PickerContent } from 'modals/s'
import Content from './content'

const GroupPersonPicker = ({ salt, ...props }) => {
    const {
        type,
        id,
        show = false,
        dismiss,
        ...content
    } = props

    return (
        <Modal
            show={show}
            dismiss={dismiss}
            contentWrapper={PickerContent}
            key={`modal:group-person-picker:${salt}`}>
            <GroupClientStateProvider
                type={type}
                id={id}>
                <Content
                    {...content}
                    salt={salt} />
            </GroupClientStateProvider>
        </Modal>
    )
}

export default GroupPersonPicker